import { render, staticRenderFns } from "./StarredIcon.vue?vue&type=template&id=5e901990&scoped=true"
import script from "./StarredIcon.vue?vue&type=script&lang=js"
export * from "./StarredIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e901990",
  null
  
)

export default component.exports